export default __webpack_public_path__ + "static/media/1718 spice rack top.edfd9c8e.png";